import { FC } from "react";

// Colores hardcoded: paleta de marca AROC (#0E2747 grafito, #2D6BFF azul pulso).
// NO cambiar sin discusión con Edgar Josué.
interface AROCIconProps { size?: number; className?: string; }

export const AROCIcon: FC<AROCIconProps> = ({ size = 64, className }) => (
  <svg
    viewBox="0 0 220 220"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label="AROC"
  >
    <g transform="translate(20, 14)">
      <circle cx="100" cy="100" r="88" fill="none" stroke="#0E2747" strokeWidth="6" />
      <line x1="100" y1="2" x2="100" y2="20" stroke="#0E2747" strokeWidth="4" strokeLinecap="round" />
      <line x1="100" y1="180" x2="100" y2="198" stroke="#0E2747" strokeWidth="4" strokeLinecap="round" />
      <line x1="2" y1="100" x2="20" y2="100" stroke="#0E2747" strokeWidth="4" strokeLinecap="round" />
      <line x1="60" y1="170" x2="100" y2="50" stroke="#0E2747" strokeWidth="14" strokeLinecap="round" />
      <line x1="140" y1="170" x2="100" y2="50" stroke="#0E2747" strokeWidth="14" strokeLinecap="round" />
      <path
        d="M 35 115 L 80 115 L 92 95 L 104 135 L 116 115 L 195 115"
        fill="none"
        stroke="#2D6BFF"
        strokeWidth="9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M 188 100 L 215 115 L 188 130 Z" fill="#2D6BFF" />
    </g>
  </svg>
);

export default AROCIcon;
